<template>
  <page>
    <div :load="doInit">
      <v-card>
        <v-card-text>
          <form>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <!-- <v-card-title>
                <div class="body-2">Date Ranges</div>
              </v-card-title> -->
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Date Ranges</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <cal-picker v-model="reportForm.fromDate" :label="labels.fromDate" v-validate="fromDateValidation(reportForm.toDate)" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
                            </v-flex>
                            <v-flex xs6>
                              <cal-picker v-model="reportForm.toDate" :label="labels.toDate" v-validate="toDateValidation(reportForm.fromDate)" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="reportForm.fromDate"></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-spacer class="mt-2"></v-spacer>
              <!-- <v-divider class="mt-3 mb-3"></v-divider>
              <v-card-title>
                <div class="body-2">Filters</div>
              </v-card-title> -->
              <v-expansion-panels v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-autocomplete
                                :items="directRIList"
                                v-model="reportForm.dri"
                                :label="labels.dri"
                                item-text="label"
                                item-value="value"
                                data-vv-name="dri"
                                :data-vv-as="labels.dri"
                                :error-messages="errors.collect('dri')"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="reportForm.polType"
                                :label="labels.polType"
                                :error-messages="errors.collect('polType')"
                                :data-vv-as="labels.polType"
                                data-vv-name="polType"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('polType')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                              v-model="reportForm.execIC"
                              :label="labels.execIC"
                              :error-messages="errors.collect('form.execIC')"
                              :data-vv-as="labels.execIC"
                              v-validate="'required'"
                              data-vv-name="reportForm.execIC"
                              append-icon="mdi-magnify"
                              @click:append="doHelplist('multiExecInChargeHelpList')"
                              readonly
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
              <v-layout row wrap>
                <v-flex xs4 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    Export
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="reportForm.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
                <v-flex xs4 class="pt-3">
                  <v-checkbox
                    dense
                    v-model="reportForm.rptParam"
                    :label="labels.rptParam"
                    :error-messages="errors.collect('rptParam')"
                    data-vv-name="rptParam"
                    :data-vv-as="labels.rptParam"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
      </v-card>
      <v-dialog v-model="multiPolTypeHelpList" width="900px" persistent>
        <multi-pol-type-help-list v-show="multiPolTypeHelpList" :pt="reportForm.polType" @close="doCloseHelpList" @doAssign="doAssign($event)"></multi-pol-type-help-list>
        <!-- clone a new array and pass it to child to prevent the array in parent from mutated by child without being aware of it -->
      </v-dialog>
      <v-dialog v-model="multiExecInChargeHelpList" width="900px" persistent>
        <multi-exec-in-charge-help-list v-show="multiExecInChargeHelpList" :execic="reportForm.execIC" @close="doCloseHelpList" @doAssign="doAssign($event)"></multi-exec-in-charge-help-list>
        <!-- clone a new array and pass it to child to prevent the array in parent from mutated by child without being aware of it -->
      </v-dialog>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MultiExecInChargeHelpList from '@/components/core/common/dialog/MultiExecInChargeHelpList'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
export default {
  data() {
    return {
      labels: {
        fromDate: 'From Expiry Date*',
        toDate: 'To Expiry Date*',
        polType: 'Policy Type(s)',
        execIC: 'Executive In-charge(s)',
        rptParam: 'Print report runtime parameters',
        dri: 'Direct / RI Inwards'
      },
      reportForm: {
        fromDate: null,
        toDate: null,
        polType: 'All',
        execIC: 'All',
        dri: null,
        subTotal: null,
        pageBreak: null,
        rptParam: null,
        format: null
      },
      supportedFormat: [],
      menu: {},
      submitting: false,
      helplist: false,
      multiPolTypeHelpList: false,
      multiExecInChargeHelpList: false,
      rptHistory: false,
      panel1: [0],
      panel2: [0],
      panel4: [0]
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
      const apiURI = this.rptMenu.initPolDueExp
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
            this.reportForm.fromDate = ''
            this.reportForm.toDate = ''
            this.reportForm.polType = 'All'
            this.reportForm.execIC = 'All'
            this.reportForm.dri = '1'
            this.reportForm.subTotal = ''
            this.reportForm.pageBreak = ''
            this.reportForm.rptParam = false
          }
        } catch (err) {
          throw err
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      debugger
      const apiURI = this.menu.exportDetail
      if (apiURI) {
        this.submitting = true
        try {
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doHelplist(field) {
      this.helplist = true
      switch (field) {
        case 'multiExecInChargeHelpList': {
          this.multiExecInChargeHelpList = true
          break
        }
        case 'polType': {
          this.multiPolTypeHelpList = true
          break
        }
        default: {
          this.helplist = false
          this.multiPolTypeHelpList = false
          this.multiExecInChargeHelpList = false
          break
        }
      }
    },
    doAssign(data) {
      if (this.multiPolTypeHelpList) {
        this.reportForm.polType = []
        this.reportForm.polType = data.finalSelectedItems.toString()
      }
      if (this.multiExecInChargeHelpList) {
        this.reportForm.execIC = []
        this.reportForm.execIC = data.finalSelectedItems.toString()
      }
    },
    processRptKey(rptKey) {
      this.resetMessages()
      // For the Report Job History only
      JSON.parse(rptKey, (key, value) => {
        switch (key) {
          case 'fromDate': {
            this.reportForm.fromDate = new Date(value)
            break
          }
          case 'toDate': {
            this.reportForm.toDate = new Date(value)
            break
          }
          case 'polType': {
            this.reportForm.polType = value
            break
          }
          case 'execIC': {
            this.reportForm.execIC = value
            break
          }
          case 'dri': {
            this.reportForm.dri = value
            break
          }
          case 'rptParam': {
            this.reportForm.rptParam = value
            break
          }
          case 'format': {
            this.reportForm.format = value
            break
          }
          default: {
            break
          }
        }
      })
    },
    doClose(rptKey) {
      if (rptKey !== undefined && rptKey !== null) {
        this.processRptKey(rptKey)
      }
      this.helplist = false
      this.rptHistory = false
    },
    doCloseHelpList(rptKey) {
      this.helplist = false
      this.multiPolTypeHelpList = false
      this.multiExecInChargeHelpList = false
    },
    formatBoolean(xBoolean) {
      return xBoolean ? 'Yes' : 'No'
    },
    clone(arr) {
      return clone(arr)
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    directRIList() {
      return [
        { label: 'Both', value: 'B' },
        { label: 'Direct', value: '1' },
        { label: 'RI Inwards', value: '0' }
      ]
    },
    booleanList() {
      return [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ]
    }
  },
  watch: {
    supportedList(value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  components: {
    MultiPolTypeHelpList,
    MultiExecInChargeHelpList
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style></style>
